<template>
  <div
    class="form-check form-check-radio"  :key="k"
    :class="[inlineClass, { disabled: disabled }]"
  >
    <label :for="cbId" class="form-check-label" :style="{'color': labelColor, 'font-family': fontFamily}">
      <input
        :id="cbId"
        class="form-check-input"
        type="radio"
        :disabled="disabled"
        :value="name"
        v-model="model"
      />
      <slot></slot> <span class="form-check-sign"></span>
    </label>
  </div>
</template>
<script>
export default {
  name: 'base-radio',
  props: {
    name: {
      type: [String, Number],
      description: 'Radio label'
    },
    disabled: {
      type: Boolean,
      description: 'Whether radio is disabled'
    },
    value: {
      type: [String, Boolean],
      description: 'Radio value'
    },
    inline: {
      type: Boolean,
      description: 'Whether radio is inline'
    },
    checkMarkColor: {
      type: String,
      default: '#232f3e'
    },
    borderColor: {
      type: String,
      default: '#e14eca'
    },
    labelColor: {
      type: String,
      default: '#e14eca'
    },
    fontFamily: {
      type: String,
      default: 'Poppins'
    }
  },
  data() {
    return {
      cbId: '',
      k: 0
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
      return '';
    }
  },
  methods: {
    updateCSSVariable() {
      // Update CSS variables
      console.log('setting property')
      document.documentElement.style.setProperty('--checkmark-color', this.checkMarkColor);
      document.documentElement.style.setProperty('--border-color', this.borderColor);
    }
  },
  mounted() {
    this.updateCSSVariable();
  },
  created() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2);
  }
};
</script>

<style>
.form-check-radio .form-check-sign::before,
.form-check-sign::after{
  border: 1px solid var(--border-color) ;
  color: var(--checkmark-color) !important;
}
</style>
